/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/ban-ts-comment */
import { createStore, createApi, createEffect, sample, combine } from 'effector';

import { strategyDictionaryApi } from './strategyDictionary';
import { getStrategies, sandboxModerate, sandboxRequestModerate, toSandbox } from '../api';
import { User$ } from './user';
import { RequestModerate } from '../types/requestModerate';
import { Strategy, StrategyStatus } from '../types/strategy';
import { UserRoles } from '../types/userRoles';

type TStrategies$State = Strategy[];

export const Strategies$ = createStore<TStrategies$State>([]);

const { set, update } = createApi(Strategies$, {
  // @ts-ignore
  set: (state, { result }) => {
    return result.result === undefined ? state : result.result;
  },
  // @ts-ignore
  update: (state, { result }) => {
    if (result.success) {
      // @ts-ignore
      const strategy = result.result;
      // @ts-ignore
      const strategies = state.filter((item) => item.id !== strategy.id);

      return [...strategies, strategy];
    }

    return state;
  },
});

Strategies$.watch((state) => {
  const strategies = state.map((item) => ({
    id: item.id,
    name: item.name,
  }));
  strategyDictionaryApi.add(strategies);
});

export const strategiesApi = {
  get: createEffect().use(getStrategies),
  requestModerate: createEffect<RequestModerate, {}, {}>().use(sandboxRequestModerate),
  moderate: createEffect<RequestModerate, {}, {}>().use(sandboxModerate),
  toSandbox: createEffect<{ strategyId: string }, {}, {}>().use(toSandbox),
};

sample({
  clock: strategiesApi.get.done,
  target: set,
});

sample({
  clock: strategiesApi.requestModerate.done,
  target: update,
});

sample({
  clock: strategiesApi.moderate.done,
  target: update,
});

sample({
  clock: strategiesApi.toSandbox.done,
  target: update,
});

const ROLES_WITH_FULL_STRATEGY_ACCESS = [UserRoles.Administrator, UserRoles.Manager, UserRoles.RiskManager];

export const StrategiesForList$ = combine(Strategies$, User$, (strategies, user) => {
  if (user?.role && ROLES_WITH_FULL_STRATEGY_ACCESS.includes(user.role)) {
    return strategies;
  }

  return strategies.filter((s) => s.status === StrategyStatus.Standard);
});
